"use strict";

var _interopRequireDefault = require("/root/www/xmg-cms-fe/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetRouter = resetRouter;
exports.default = exports.constantRoutes = void 0;

var _interopRequireWildcard2 = _interopRequireDefault(require("/root/www/xmg-cms-fe/node_modules/@babel/runtime-corejs2/helpers/interopRequireWildcard"));

var _vue = _interopRequireDefault(require("vue"));

var _vueRouter = _interopRequireDefault(require("vue-router"));

var _layout = _interopRequireDefault(require("@/layout"));

_vue.default.use(_vueRouter.default);
/* Layout */


/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
var constantRoutes = [{
  path: '/login',
  component: function component() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/login/index'));
    });
  },
  hidden: true
}, {
  path: '/404',
  component: function component() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/404'));
    });
  },
  hidden: true
}, {
  path: '/',
  component: _layout.default,
  redirect: '/dashboard',
  children: [{
    path: 'dashboard',
    name: '仙猫馆',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/dashboard/index'));
      });
    },
    meta: {
      title: '仙猫馆',
      icon: 'dashboard'
    }
  }]
}, {
  path: '/cats',
  component: _layout.default,
  redirect: '/cats/list',
  name: 'Example',
  meta: {
    title: '猫咪管理',
    icon: 'example'
  },
  children: [{
    path: 'details',
    name: '新增',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/cats/edit'));
      });
    },
    meta: {
      title: '新增',
      icon: 'form'
    }
  }, {
    path: 'details/:id',
    name: '修改',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/cats/edit'));
      });
    },
    meta: {
      title: '修改信息',
      icon: 'form'
    },
    hidden: true
  }, {
    path: 'list',
    name: '列表',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/cats/list'));
      });
    },
    meta: {
      title: '列表',
      icon: 'tree'
    }
  }, {
    path: 'sort',
    name: '排序（大猫）',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/cats/cat-sort'));
      });
    },
    meta: {
      title: '排序（大猫）',
      icon: 'nested'
    }
  }, {
    path: 'kitten-sort',
    name: '排序（幼猫）',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/cats/kitten-sort'));
      });
    },
    meta: {
      title: '排序（幼猫）',
      icon: 'nested'
    }
  }]
}, {
  path: '/cat-base',
  component: _layout.default,
  redirect: '/cat-base/tags',
  name: 'Example',
  meta: {
    title: '猫咪标签',
    icon: 'table'
  },
  children: [{
    path: '/cat-base/tags',
    name: '列表',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/cat-base/tags'));
      });
    },
    meta: {
      title: '列表',
      icon: 'form'
    }
  }, {
    path: 'list',
    name: '排序（大猫）',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/cat-base/tags-sort'));
      });
    },
    meta: {
      title: '排序（大猫）',
      icon: 'tree'
    }
  }, {
    path: '/cat-base/details',
    name: '编辑猫咪种类品质介绍',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/cat-base/edit'));
      });
    },
    meta: {
      title: '品种介绍',
      icon: 'form'
    },
    hidden: true
  }, {
    path: '/cat-base/details/:id',
    name: '编辑猫咪种类品质介绍',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/cat-base/edit'));
      });
    },
    meta: {
      title: '品种介绍',
      icon: 'form'
    },
    hidden: true
  }]
}, {
  path: '/feedback',
  component: _layout.default,
  redirect: '/feedback/list',
  name: 'Example',
  meta: {
    title: '用户评价',
    icon: 'table'
  },
  children: [{
    path: '/feedback/edit',
    name: '新增',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/feedback/edit'));
      });
    },
    meta: {
      title: '新增',
      icon: 'form'
    }
  }, {
    path: '/feedback/edit/:id',
    name: '编辑',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/feedback/edit'));
      });
    },
    meta: {
      title: '编辑',
      icon: 'form'
    },
    hidden: true
  }, {
    path: '/feedback/list',
    name: '列表',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/feedback/index'));
      });
    },
    meta: {
      title: '列表',
      icon: 'form'
    } // {
    //   path: '/cat-base/type',
    //   name: '猫标签',
    //   component: () => import('@/views/cat-base/type/index'),
    //   meta: { title: '品种详情', icon: 'form' }
    // }

  }]
}, // {
//   path: '/cats',
//   component: Layout,
//   redirect: '/cats/list',
//   name: 'Example',
//   meta: { title: '仙猫录', icon: 'example' },
//   children: [
//     {
//       path: 'list',
//       name: '仙猫列表',
//       component: () => import('@/views/table/index'),
//       meta: { title: '仙猫列表', icon: 'tree' }
//     },
//     {
//       path: 'details',
//       name: '添加猫咪',
//       component: () => import('@/views/tree/index'),
//       meta: { title: '添加猫咪', icon: 'table' }
//     }
//   ]
// },
// {
//   path: '/form',
//   component: Layout,
//   children: [
//     {
//       path: 'index',
//       name: 'Form',
//       component: () => import('@/views/form/index'),
//       meta: { title: 'Form', icon: 'form' }
//     }
//   ]
// },
// {
//   path: '/nested',
//   component: Layout,
//   redirect: '/nested/menu1',
//   name: 'Nested',
//   meta: {
//     title: 'Nested',
//     icon: 'nested'
//   },
//   children: [
//     {
//       path: 'menu1',
//       component: () => import('@/views/nested/menu1/index'), // Parent router-view
//       name: 'Menu1',
//       meta: { title: 'Menu1' },
//       children: [
//         {
//           path: 'menu1-1',
//           component: () => import('@/views/nested/menu1/menu1-1'),
//           name: 'Menu1-1',
//           meta: { title: 'Menu1-1' }
//         },
//         {
//           path: 'menu1-2',
//           component: () => import('@/views/nested/menu1/menu1-2'),
//           name: 'Menu1-2',
//           meta: { title: 'Menu1-2' },
//           children: [
//             {
//               path: 'menu1-2-1',
//               component: () => import('@/views/nested/menu1/menu1-2/menu1-2-1'),
//               name: 'Menu1-2-1',
//               meta: { title: 'Menu1-2-1' }
//             },
//             {
//               path: 'menu1-2-2',
//               component: () => import('@/views/nested/menu1/menu1-2/menu1-2-2'),
//               name: 'Menu1-2-2',
//               meta: { title: 'Menu1-2-2' }
//             }
//           ]
//         },
//         {
//           path: 'menu1-3',
//           component: () => import('@/views/nested/menu1/menu1-3'),
//           name: 'Menu1-3',
//           meta: { title: 'Menu1-3' }
//         }
//       ]
//     },
//     {
//       path: 'menu2',
//       component: () => import('@/views/nested/menu2/index'),
//       meta: { title: 'menu2' }
//     }
//   ]
// },
// {
//   path: 'external-link',
//   component: Layout,
//   children: [
//     {
//       path: 'https://panjiachen.github.io/vue-element-admin-site/#/',
//       meta: { title: 'External Link', icon: 'link' }
//     }
//   ]
// },
// 404 page must be placed at the end !!!
{
  path: '*',
  redirect: '/404',
  hidden: true
}];
exports.constantRoutes = constantRoutes;

var createRouter = function createRouter() {
  return new _vueRouter.default({
    // mode: 'history', // require service support
    scrollBehavior: function scrollBehavior() {
      return {
        y: 0
      };
    },
    routes: constantRoutes
  });
};

var router = createRouter(); // Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465

function resetRouter() {
  var newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

var _default = router;
exports.default = _default;